<template>
  <div class="body d-flex py-lg-3 py-md-2">
    <div class="container-xxl">
      <!-- Existing Content -->
      <div class="row clearfix">
        <div class="col-md-12">
          <!-- Header Section -->
          <div class="card border-0 mb-2 no-bg">
            <div class="card-header py-1 px-0 d-sm-flex align-items-center justify-content-between main-button-area">
              <Teleport to="body">
                <div v-if="selectedRows.length > 0"
                  class="checkbox-btn">
                  <span>
                      ({{ selectedRows.length }}) selected requests
                  </span>
                  <div class="d-flex mt-sm-0 mt-3 justify-content-between">

                  <button type="button" class="ms-0 ms-sm-3 btn" style="line-height:1.2; font-weight: normal; max-height: 58px; background-color: rgb(107, 219, 107);" id="acceptSelectedHoursBtn" @click.prevent="acceptSelectedHours">Accept Selected Hours</button>
                  <button class="ms-0 ms-sm-3 btn" type="button" style="line-height:1.2; font-weight: normal; max-height: 58px; background-color: rgb(241, 111, 111);" id="rejectSelectedHoursBtn" @click.prevent="rejectSelectedHours">Reject Selected Hours</button>
                  
                  <!--  <button type="button" class="ms-0 ms-sm-3 btn" style="line-height:1.2; font-weight: normal; max-height: 58px; background-color: rgb(107, 219, 107);" id="acceptSelectedHoursBtn" @click.prevent="acceptSelectedHours">Accept Selected Hours</button>-->
                  <!--  <button class="ms-0 ms-sm-3 btn" type="button" style="line-height:1.2; font-weight: normal; max-height: 58px; background-color: rgb(241, 111, 111);" id="rejectSelectedHoursBtn" @click.prevent="rejectSelectedHours">Reject Selected Hours</button>-->
                  </div>
                </div>
              </Teleport>            
            </div>
          </div>
        </div>
      </div>

      <!-- hours requests Table -->
      <div class="row clearfix g-3">
        <div class="col-sm-12">
          <div class="card mb-3">
            <div class="card-body table-responsive" style="width: 100%; padding: 0; margin: 0 auto">
              <div class="requests-body">
                <div v-for="(hours, index) in data" :key="hours.id"
                  :class="{'approved': hours.accepted === 1, 'not-approved': hours.accepted === 0 }" class="seperate-requests">
                    <div v-if="hours.accepted === null" class="check-box">
                      <input type="checkbox" v-model="selectedRows" :value="hours.id">
                    </div>
                
                  <div class="container-requests">
                    <div class="container-requests-header">
                        <div><h5>Requested by</h5>{{ hours.username }}</div>
                          <div class="container-requests-header2">
                            <div><h5>Request Date</h5>{{ hours.created_at }}</div>
                            <div><h5>Work Date</h5>{{ hours.day }}</div>
                          </div>
                    </div>
                    <div class="grid-container-requests">    
                        <div class="grid__item"><h5>Project</h5>{{ hours.previousProject_title }}</div>
                        <div class="grid__item"><h5>Project (New)</h5>{{ hours.requestedProject.title }}</div>
                        <div class="grid__item"><h5>Task</h5>{{ hours.hourTask.title }}</div>
                        <div class="grid__item"><h5>Task (New)</h5>{{ hours.requestedTask.title }}</div>
                        <div class="grid__item"><h5>Hours</h5>{{ hours.hour_from }} έως {{ hours.hour_to }}</div>
                        <div class="grid__item"><h5>Hours (New)</h5>{{ hours.info_from }} έως {{ hours.info_to }}</div>
                    </div>
                  </div>
                  <div class="grid-container-requests-description">
                    <div><h5>Description</h5>{{ hours.body }}</div>
                    <div class="requestButtons" style="display:flex; align-items: end; justify-content: flex-end; width: 100%; gap: 5px;">
                      <template v-if="hours.accepted === null">
                        <button type="button" class="ms-0 ms-sm-3 btn" style="background-color: rgb(107, 219, 107); max-height:50px;" id="acceptSelectedHoursBtn" @click="acceptHourChange(hours.id)">Accept Request
                          
                        </button>
                        <button class="ms-0 ms-sm-3 btn" type="button" style="background-color: rgb(241, 111, 111); max-height:50px;" id="rejectSelectedHoursBtn" @click="rejectHourChange(hours.id)">Reject Request
                          
                        </button>
                      </template>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Pagination -->
              <nav aria-label="Page navigation">
                <ul class="pagination mt-4" v-if="paginationLinks && paginationLinks.length > 0">
                  <li class="page-item" v-for="(paginationLink, index) in paginationLinks" :key="index"
                      :class="{ active: paginationLink.active }">
                    <router-link :to="{ path: $route.path, query: { ...filters, page: getPageFromUrl(paginationLink.url) } }"
                                 v-if="paginationLink.url">
                      <span class="page-link" v-html="paginationLink.label"></span>
                    </router-link>
                    <span class="page-link" v-else v-html="paginationLink.label"></span>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>


<!-- CheckBox Accept Day Off Modal -->
      <div class="modal fade" id="accept-hourchange-form" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title fw-bold" id="acceptHoursRequestsLabel">Accept Hour Change?</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <input name="id" id="id" type="hidden" v-model="hoursData.id" />
              <div class="mb-3">
                The changes will be finalized.
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" @click.prevent="acceptSelectedHours">Accept</button>
            </div>
          </div>
        </div>
      </div>

<!--CheckBox Reject Day Off Modal -->
      <div class="modal fade" id="reject-hourchange-form" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title fw-bold" id="rejectHoursRequestsLabel">Reject Hour Change?</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <input name="id" id="id" type="hidden" v-model="hoursData.id" />
              <div class="mb-3">
                The changes will be rejected, and the hour entry will remain unchanged.
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              <button type="button" class="reject btn btn-primary" @click.prevent="rejectSelectedHours">Reject</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Accept Day Off Modal -->
      <div class="modal fade" id="accept-hourchange-form" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title fw-bold" id="acceptHoursRequestsLabel">Accept Hour Change?</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <input name="id" id="id" type="hidden" v-model="hoursData.id" />
              <div class="mb-3">
                The changes will be finalized.
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" @click="confirmAcceptHourChange">Accept</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Reject Day Off Modal -->
      <div class="modal fade" id="reject-hourchange-form" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title fw-bold" id="rejectHoursRequestsLabel">Reject Hour Change?</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <input name="id" id="id" type="hidden" v-model="hoursData.id" />
              <div class="mb-3">
                The changes will be rejected, and the hour entry will remain unchanged.
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              <button type="button" class="reject btn btn-primary"  @click="confirmRejectHourChange">Reject</button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useFetchData } from '@/composables/useFetchData';
import { fetchAll, accept, reject } from '@/services/hoursrequests';
import { useToast } from 'vue-toastification';

const defaultHoursData = {
  id: '',
  user: '',
  from: '',
  to: '',
  description: ''
};

export default {
  name: 'HoursRequests',
  setup() {
    const route = useRoute();
    const router = useRouter();

    const toast = useToast();

    const { data, paginationLinks, filters, updateFilters, fetchData, sortBy } = useFetchData(fetchAll, { page: route.query.page || 1 }, { page: 1 });

    const hoursData = ref(defaultHoursData);
    const selectedRows = ref([]); // Track selected rows

    // Methods
    const acceptHourChange = (infoId) => {
      hoursData.value.id = infoId;
      $('#accept-hourchange-form').modal('toggle');
    };

    const rejectHourChange = (infoId) => {
      hoursData.value.id = infoId;
      $('#reject-hourchange-form').modal('toggle');
    };

    const confirmAcceptHourChange = async () => {
      try {
        const response = await accept(hoursData.value);
        if (response.data.success) {
          toast.success(response.data.message);
          $('#accept-hourchange-form').modal('toggle');
          fetchData();
          selectedRows.value = []; // Reset selected rows
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        toast.error('Error accepting request');
      }
    };

    const confirmRejectHourChange = async () => {
      try {
        const response = await reject(hoursData.value);
        if (response.data.success) {
          toast.success(response.data.message);
          $('#reject-hourchange-form').modal('toggle');
          fetchData();
          selectedRows.value = []; // Reset selected rows
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        toast.error('Error rejecting request');
      }
    };

    const acceptSelectedHours = async () => {
      if (!selectedRows.value.length) {
        toast.error('Δεν έχετε επιλέξει ώρες');
        return;
      }

      try {
        const promises = selectedRows.value.map(id => accept({ id, accepted: 1 }));
        const responses = await Promise.all(promises);

        const successCount = responses.filter(response => response.data.success).length;
        const failureCount = responses.length - successCount;

        if (successCount > 0) {
          toast.success(`${successCount} requests accepted successfully.`);
        }

        if (failureCount > 0) {
          toast.error(`${failureCount} requests failed to accept.`);
        }

        fetchData();
        selectedRows.value = []; // Reset selected rows
      } catch (error) {
        toast.error('Error accepting selected requests');
      }
    };

    const rejectSelectedHours = async () => {
      if (!selectedRows.value.length) {
        toast.error('Δεν έχετε επιλέξει ώρες για απόρριψη');
        return;
      }

      try {
        const promises = selectedRows.value.map(id => reject({ id, accepted: 0 }));
        const responses = await Promise.all(promises);

        const successCount = responses.filter(response => response.data.success).length;
        const failureCount = responses.length - successCount;

        if (successCount > 0) {
          toast.success(`${successCount} hours requests rejected successfully.`);
        }

        if (failureCount > 0) {
          toast.error(`${failureCount} hours requests failed to reject.`);
        }

        fetchData();
        selectedRows.value = []; // Reset selected rows
      } catch (error) {
        toast.error('Error rejecting selected requests');
      }
    };

    const getPageFromUrl = (url) => {
      if (!url) return null;
      const urlObj = new URL(url, window.location.origin);
      return urlObj.searchParams.get('page');
    };

    const searchAction = () => {
      setTimeout(() => {
        router.push({path: '/hours-requests', query: {...route.query, search: $("#main-search-input").val()}});
      }, 300);
    };

    // Fetch data on component mount
    onMounted(async () => {
        $(document.body).on('keyup', "#main-search-input", searchAction).on('click', "#main-search-input", searchAction);
        await fetchData();
    });

    onUnmounted(() => {
        $(document.body).off('keyup', "#main-search-input", searchAction).off('click', "#main-search-input", searchAction);
    });

    return {
      data,
      paginationLinks,
      filters,
      updateFilters,
      fetchData,
      hoursData,
      selectedRows,
      getPageFromUrl,
      acceptHourChange,
      confirmAcceptHourChange,
      rejectHourChange,
      confirmRejectHourChange,
      acceptSelectedHours,
      rejectSelectedHours, sortBy
    };
  },
  metaInfo: {
    title: 'Hours Requests',
    meta: [
      { name: 'description', content: 'MIS - Hours Requests' },
      { property: 'og:title', content: 'MIS - Hours Requests' },
      { property: 'og:description', content: 'This is the hours requests page.' }
    ]
  }
};
</script>



<style scoped>
.dropdown-menu.show {
  display: block;
}
.checkbox-btn{
  z-index:1000;
  position: fixed;
  top: 3%;
  left: 20%;
  padding: 15px 20px;
  background-color: white;
  box-shadow: 0px 2px 14px 8px #b5aeae;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-height: 10px;
}
.reject.btn.btn-primary{
  background-color: rgb(175 69 71);
  border:none;
}
.reject.btn.btn-primary:hover{
  background-color:rgb(128 34 36);
}
.approved.seperate-requests{
  box-shadow: inset 0px 0px 60px 0px #4e8528ab;
  background-color: #dfffcc91;
}
.approved.seperate-requests.h5{

}
.not-approved.seperate-requests{
  background-color: #ffeff0;
  box-shadow: inset 0px 0px 60px 0px #9300007a;
}
.seperate-requests{
  border: 2px solid;
  border-color: lightgray;
  box-shadow: 13px 5px 13px 5px rgba(26, 28, 31, 0.21);
  border-radius: 8px;
  min-height: 320px;
  max-width: 1400px;
  padding: 20px;
  display: flex;
  margin: 0px 18px 50px 18px;
}
.requests-body{
  display: flex;
  flex-direction: column;
  }
.container-requests-header{
  display: flex;
  gap: 70px;
  line-height: 1.1;
}
.container-requests-header2{
  display: flex;
  gap: 70px;
}
.grid-container-requests{
  display: grid;
  grid-template-columns: repeat(2, [col-start] 1fr);
  gap: 15px;
  margin-top: 18px;
}
.grid__item {
  white-space: normal;
  word-break: break-word;
  z-index: 1;
  border-top-style: solid;
  border-color: lightgrey;
  padding-top: 12px;
  line-height: 1.1em;
}
.grid-container-requests-description{
  width: 40%;
  display: flex;
  flex-wrap: wrap;
  align-content: space-between;
  padding: 20px 20px 0px 20px;
  border-inline-start: dashed;
  border-color: lightgrey;
}
.container-requests{
  padding: 20px;
  width: 60%;
}


@media screen and (max-width: 768px) {
  .container-requests-header.h5{
    font-size: 1.1rem;
  }
  .container-requests{
    padding: 10px 3px;
    width: 100%;
  }
  .container-requests-header{
    display: block;
  }
  .container-requests-header2{
    gap: 55px;
    margin-top: 20px;
  }
  .grid-container-requests-description{
    width: 100%;
    gap: 10px;
    padding: 3px;
    border-inline-start: none;
    border-top: dashed;
    border-color: lightgrey;
    }
  .grid-container-requests{
    display: block;
  }
  .requests-body{
    display: block;
  }
  .grid__item{
    padding: 10px 0px;
  }
  .seperate-requests{
    display: flex;
    flex-wrap: wrap;
  }
  .seperate-requests.btn{
    font-size: 0.9em;
    color: #020202db;
  }
}
</style>